import { render, staticRenderFns } from "./TableSettingsPresetItem.vue?vue&type=template&id=0ccdb74f"
import script from "./TableSettingsPresetItem.vue?vue&type=script&lang=js"
export * from "./TableSettingsPresetItem.vue?vue&type=script&lang=js"
import style0 from "./TableSettingsPresetItem.vue?vue&type=style&index=0&id=0ccdb74f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports